module.exports = __webpack_public_path__ + "static/media/mv_resume_new.0ad900f9.png";